import { Link } from "react-router-dom";
import { Instagram, MessageCircle, Mail } from "lucide-react";
import { NAV_LINKS, scrollToId, site, waLink, WA_MESSAGES } from "../config/site";
import { trackEvent } from "../lib/analytics";

const SERVICE_LINKS = [
  "Criação de Sites Profissionais",
  "Tráfego Pago",
  "Rastreamento de Conversões",
  "Estratégia e Crescimento Digital",
];

export const Footer = () => {
  const year = new Date().getFullYear();
  const go = (e, hash) => {
    e.preventDefault();
    scrollToId(hash);
  };
  return (
    <footer data-testid="footer" className="border-t border-white/8 bg-[#030405]">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-12">
        <div>
          <a href="#inicio" onClick={(e) => go(e, "#inicio")} data-testid="footer-logo" className="flex items-center gap-3">
            <img src="/assets/logo.jpg" alt="Logotipo GOBAX" width={44} height={44} className="h-11 w-11 rounded-full ring-1 ring-white/20" />
            <span className="leading-none">
              <span className="block font-display text-lg font-extrabold tracking-wide">GOBAX</span>
              <span className="block font-mono text-[9px] uppercase tracking-[0.28em] text-gb-gray">{site.tagline}</span>
            </span>
          </a>
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-gb-gray">
            Estratégia digital, criação de sites profissionais, tráfego pago e rastreamento de
            conversões para negócios que querem crescer com clareza.
          </p>
          <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.25em] text-gb-silver">
            {site.slogan}
          </p>
        </div>

        <nav aria-label="Navegação do rodapé">
          <h3 className="font-mono text-[10px] uppercase tracking-[0.25em] text-gb-silver">Navegação</h3>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.hash}>
                <a href={l.hash} onClick={(e) => go(e, l.hash)} data-testid={`footer-link-${l.hash.slice(1)}`} className="text-sm text-gb-gray transition-colors hover:text-gb-white">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="Serviços">
          <h3 className="font-mono text-[10px] uppercase tracking-[0.25em] text-gb-silver">Serviços</h3>
          <ul className="mt-5 space-y-3">
            {SERVICE_LINKS.map((s) => (
              <li key={s}>
                <a href="#solucoes" onClick={(e) => go(e, "#solucoes")} data-testid={`footer-service-${s.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="text-sm text-gb-gray transition-colors hover:text-gb-white">
                  {s}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="font-mono text-[10px] uppercase tracking-[0.25em] text-gb-silver">Contato</h3>
          <ul className="mt-5 space-y-3">
            {site.whatsappNumber && (
              <li>
                <a
                  href={waLink(WA_MESSAGES.default)}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackEvent("whatsapp_click", { location: "footer" })}
                  data-testid="footer-whatsapp-link"
                  className="inline-flex items-center gap-2 text-sm text-gb-gray transition-colors hover:text-gb-white"
                >
                  <MessageCircle className="h-4 w-4" aria-hidden="true" />
                  {site.whatsappDisplay || "WhatsApp"}
                </a>
              </li>
            )}
            {site.instagramUrl && (
              <li>
                <a href={site.instagramUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="inline-flex items-center gap-2 text-sm text-gb-gray transition-colors hover:text-gb-white">
                  <Instagram className="h-4 w-4" aria-hidden="true" />
                  @gobaxdigitalhub
                </a>
              </li>
            )}
            {site.email && (
              <li>
                <a href={`mailto:${site.email}`} data-testid="footer-email-link" className="inline-flex items-center gap-2 text-sm text-gb-gray transition-colors hover:text-gb-white">
                  <Mail className="h-4 w-4" aria-hidden="true" />
                  {site.email}
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>

      <div aria-hidden="true" className="select-none overflow-hidden border-t border-white/5">
        <p data-testid="footer-wordmark" className="-mb-[4vw] bg-gradient-to-b from-white/10 to-transparent bg-clip-text text-center font-display text-[19vw] font-extrabold leading-none tracking-tight text-transparent">
          GOBAX
        </p>
      </div>

      <div className="border-t border-white/8">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-4 py-7 text-xs text-gb-gray sm:flex-row sm:px-6 lg:px-12">
          <p data-testid="footer-copyright">© {year} GOBAX — Tráfego &amp; Sites. Todos os direitos reservados.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacidade" data-testid="footer-privacy-link" className="transition-colors hover:text-gb-white">
              Política de Privacidade
            </Link>
            <button
              type="button"
              data-testid="footer-cookie-preferences"
              onClick={() => window.dispatchEvent(new Event("gobax:open-consent"))}
              className="transition-colors hover:text-gb-white"
            >
              Preferências de cookies
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
